import matchBlockElement from '../../common/helpers/match-block-element';

const isNegativeIndent = (element) => {
  if (matchBlockElement(element)) {
    return true;
  }

  return false;
};

export default isNegativeIndent;
